import { render } from "./SDGSection.vue?vue&type=template&id=361e9352"
import script from "./SDGSection.vue?vue&type=script&lang=js"
export * from "./SDGSection.vue?vue&type=script&lang=js"
script.render = render

export default script